import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import Accordion from "react-bootstrap/Accordion";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Appqr from '../../components/Appqr';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./SpeedDatingPage.css";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import Multiselect from "multiselect-react-dropdown";

const images = [
  "assests/images/romanticss-2.jpg",
  "assests/images/romantic-1.jpg",
  "assests/images/romanticss-3.jpg",
  "assests/images/romanticss-4.jpg",
];

const SpeedDatingPage = () => {
  
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    centerMode: true,
    centerPadding: '13%',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '0',
        }
      }
    ]
  };

  const [loading,setLoading] = useState(true);
  //const [selectedCity, setSelectedCity] = useState(0);


  //const [category, setCategory] = useState([]);
	const [events, setEvents] = useState([]);

  const [selected, setSelected] = useState([]);

  //const [selectedcat, setSelectedcat] = useState([]);


	const [location, setLocation] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    /* Start get even data */
	let formData1 = new FormData(); 
  formData1.append('type', '');
  formData1.append('location_type', 'speed-dating-page');
  API.post('get_events', formData1)
    .then(response => {
      setLoading(false);
    if(response.data.status === false){
      
    }else{
       setEvents(response.data.data.event);
    }                  
  }).catch(error => {
     
  });  
 /* End get even data */
 


 /* Start get location data */
  API.get('get_location')
    .then(response => {
    if(response.data.status === false){
      
    }else{
       setLocation(response.data.data);
    }                  
  }).catch(error => {
     
  });  
 /* End get location data */

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    document.title = `YFMF Speed Dating Events in Ireland`;
    document.getElementById("bodywrap").className = "speedys";

    const metaDesc = document.querySelector("meta[name='description']");
      if (metaDesc) {
        metaDesc.setAttribute("content", "Meet up to 20 singles in one night with YFMF Speed Dating. Fun, relaxed and efficient — it’s the most natural way to meet people offline.");
      }

  }, []);

  /*const setSelectedCityset = (val) => {
    setSelectedCity(val);
    
    var cat=[val];
    let formData = new FormData(); 
      formData.append('type', '');
      formData.append('location_type', 'speed-dating-page');
      if(val!==0){
      formData.append('location_id', JSON.stringify(cat));
      }
      
      API.post('get_events', formData)
        .then(response => {
          setLoading(false);
        if(response.data.status === false){
          
        }else{
           setEvents(response.data.data.event);
        }                  
      }).catch(error => {
         
      });  	
  }*/  

const handleInputChangeLoc = (selectedList) => {
    //selectedList.persist();
    setSelected(selectedList);

    

    const allNewLoc = [];
    selectedList.forEach((val) => {
      allNewLoc.push(val.id);
    });

    let formData = new FormData();
    formData.append("type", "");
    formData.append('location_type', 'speed-dating-page');
    formData.append("location_id", JSON.stringify(allNewLoc));

    API.post("get_events", formData)
      .then((response) => {
        setLoading(false);
        if (response.data.status === false) {
        } else {
          setEvents(response.data.data.event);
        }
      })
      .catch((error) => {});
  };
  

const handleLink = (is_event_private,id) => {
      window.location.href = "/event-product/"+id;
}



  return (
    <>
      <Header />

      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={
            process.env.REACT_APP_BASE_URL +
            "assests/images/speed-datingnew.jpg"
          }
          alt="QR Code"
          className="img-fluid"
        />
      </div>

      <div className="container-fluid ireland">
        <div className="row g-4">
          <div className="col-md-6 ire-left">
            <p>SPEED DATING</p>
            <h2>Real Conversations, Real ConnectionS</h2>
          </div>

          <div className="col-md-6 ire-right">
            <p>
              Speed Dating is a fun, fast-paced way to meet like-minded singles
              in real life. No swiping, no awkward first messages—just real
              conversations with people looking for genuine connections.
            </p>
            <p>
              At a YFMF Speed Dating event, you’ll meet 18 potential matches,
              each in a five-minute mini-date. The setting is relaxed, the
              atmosphere is fun, and you’ll know quickly if there’s a
              connection. After each date, mark whether you’d like to see that
              person again. If there’s a match, we’ll connect you after the
              event.
            </p>
            <div className="arrive">
              <Link
                to="/upcoming-events"
                className="btn bros-bu text-decoration-none"
              >
                BROWSE EVENTS
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid expand new-expa">
        <div className="row align-items-strech d-flex">
          {/* Left Side Content */}
          <div className="col-md-6 d-flex flex-column justify-content-between">
            <div className="tired">
              <h2>HOW IT WORKS</h2>
              <h4>What to expect </h4>
            </div>
            <div className="tired-2">
              <Link
                to="/upcoming-events"
                className="brow-bu text-decoration-none d-none d-md-inline-block"
              >
                BROWSE EVENTS
              </Link>
            </div>
          </div>

          {/* Right Side Features */}
          <div className="col-md-6 d-flex flex-column">
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/pect-1.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Purchase your ticket</h5>
                <p>
                  Choose your event date and buy your ticket online. Tickets are
                  limited.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/pect-2.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Attend the event</h5>
                <p>
                  Arrive at the event, check in with your host and receive your
                  dater card.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/pect-3.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Introduction</h5>
                <p>
                  Your host will give a quick overview on how the evening will
                  run.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/pect-4.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Begin Dating</h5>
                <p>
                  Take a seat for your first date, when you hear the bell, it’s
                  time to rotate!
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locat">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/pect-5.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Decisions</h5>
                <p>
                  On your dater card, mark off which of your dates you are
                  interested in.
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locats">
              <img
                src={
                  process.env.REACT_APP_BASE_URL + "assests/images/pect-6.png"
                }
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Matches</h5>
                <p>
                  YFMF will email you with a list of mutual matches and contact
                  details so you can get in touch!
                </p>
              </div>
            </div>
          </div>

          <div className="d-flex d-md-none order-4 tired-2 mt-3 text-center">
            <Link to="/contact" className="brow-bu text-decoration-none w-100">
              Get in touch
            </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid real-connection new-real sparks">
        <div className="row justify-content-between">
          <div className="col-md-5 d-flex flex-column justify-content-between">
            <div className="slidees ols">
              <h6>YFMF</h6>
              <h2>Meet 18 potential matches in one night</h2>
            </div>
            <div className="d-none d-md-flex justify-content-start">
              <button
                className="btn"
                onClick={() => sliderRef.current.slickPrev()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Previous"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-left-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Previous Hover"
                  />
                </div>
              </button>
              <button
                className="btn"
                onClick={() => sliderRef.current.slickNext()}
              >
                <div className="arrow-container">
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right.png"
                    }
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Next"
                  />
                  <img
                    src={
                      process.env.REACT_APP_BASE_URL +
                      "assests/images/carousel-right-hover.png"
                    }
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Next Hover"
                  />
                </div>
              </button>
            </div>
          </div>

          <div className="col-md-1"></div>

          <div className="col-md-6 pe-md-0">
            <div>
              <Slider ref={sliderRef} {...settings}>
                {images.map((img, i) => (
                  <div key={i} className={`custom-slide ${i === images.length - 1 ? 'last-slide' : ''}`}>
                    <img
                      src={process.env.REACT_APP_BASE_URL + img}
                      className="img-fluid respo"
                      alt={`Slide ${i}`}
                      style={{ width: "100%", height: "460px", borderRadius: 24, objectFit: "cover" }}
                      onError={(e) => (e.target.style.display = "none")}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
            <button
              className="btn"
              onClick={() => sliderRef.current.slickPrev()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Previous"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-left-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Previous Hover"
                />
              </div>
            </button>
            <button
              className="btn"
              onClick={() => sliderRef.current.slickNext()}
            >
              <div className="arrow-container">
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right.png"
                  }
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Next"
                />
                <img
                  src={
                    process.env.REACT_APP_BASE_URL +
                    "assests/images/carousel-right-hover.png"
                  }
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Next Hover"
                />
              </div>
            </button>
          </div>
        </div>
      </div>

      <div className="container-fluid discover disroveru pt-0">
        {/*<h1>UPCOMING RUNS</h1>*/}
        <h2 className="mb-4">Upcoming Speed Dating</h2>
        {/*<div className="tabsu row mb-5 g-4">
          <div className="col-auto dibli">
            <Link
              href="#"
              className={selectedCity === 0 ? "selected" : ""}
              onClick={(e) => {
                e.preventDefault();
                setSelectedCityset(0);
              }}
            >
              All
            </Link>
          </div>
          {location.length > 0 &&
            location.map((item, index) => {
              return (
                <div className="col-auto dibli">
                  <Link
                    href="#"
                    className={selectedCity === item.id ? "selected" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedCityset(item.id);
                    }}
                  >
                    {item.name}
                  </Link>
                </div>
              );
            })}
        </div>*/}

        <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mb-5">
            <div className="col-12 col-md-auto files">Filter by</div>
            <div className="d-flex flex-column flex-md-row gap-2 alag">
              <div className="col-12 col-md-10 fil-name mb-2 mb-md-0">
                <Multiselect
                  options={location}
                  selectedValues={selected} // Here you put your pre-selected values
                  onSelect={handleInputChangeLoc}
                  onRemove={handleInputChangeLoc}
                  displayValue="name"
                  showCheckbox
                  placeholder="Select Location"
                />
              </div>
             
            </div>
          </div>

        <div className="d-none d-md-flex row">
          {events.map((val, i) => (
            <div className="col-md-4 mb-4 joker">
              <div className="card vesi h-100 d-flex flex-column position-relative">
                <Link
                  to="#"
                  className="text-decoration-none"
                  onClick={() => handleLink(val.is_event_private,val.id)}
                >
                  <img
                    src={val.event_image}
                    className="card-img-top"
                    alt={val.event_title}
                  />
                </Link>
                <h5 className={`text-center event-cat-box${val.category_id}`} >{val.category_name}</h5>
                <div className="card-body d-flex flex-column">
                  <div className="datesx">
                    <div className="day-number">{val.day}</div>
                    <div className="day-month">{val.month}</div>  
                  </div>
                  <Link
                    to="#"
                    className="text-decoration-none"
                    onClick={() => handleLink(val.is_event_private,val.id)}
                  >
                    <h5>
                      {val.event_title}{" "}
                      {/*(Ages {val.age_start} - {val.age_end})*/}
                    </h5>
                  </Link>
                  <p>{val.event_address}</p>
                  <div className="d-flex gap-2 flex-wrap">
                  {(() => {
                if (val.age_start==='' && val.age_end==='') {
                  } else if (val.age_start!=='' && val.age_end==='') {
                    return ( <h3>Age {val.age_start}+</h3>)
                  }else if (val.age_start==='' && val.age_end!=='') {
                      return ( <h3>Age {val.age_end}+</h3>)
                  }else if (val.age_start!=='' && val.age_end!=='') {
                    return ( <h3>Ages {val.age_start} - {val.age_end}</h3>)
                  }
                })()}
                {val.tags.map((val1, index1) => {
                return (
                <h3>{val1}</h3>
              )
              })}
              </div>
                  <div className="mt-auto">
                    <Link
                      to="#"
                      className="text-decoration-none"
                      onClick={() => handleLink(val.is_event_private,val.id)}
                    >
                      <div className="get-ti">
                        <Link
                          to="#"
                          className="w-100 text-decoration-none"
                        >
                          GET TICKETS
                        </Link>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="d-block d-md-none">
          {events.length > 0 && (
            <Carousel className="p-0">
              {events.map((val, i) => (
                <Carousel.Item className="px-2 joker">
                  <div className="card position-relative">
                    <Link
                      to="#"
                      className="text-decoration-none"
                      onClick={() => handleLink(val.is_event_private,val.id)}
                    >
                      <img
                        src={val.event_image}
                        className="card-img-top"
                        alt={val.event_title}
                      />
                    </Link>
                    <h5 className={`text-center event-cat-box${val.category_id}`} >{val.category_name}</h5>
                    <div className="card-body">
                    <div className="datesx">
                      <div className="day-number">{val.day}</div>
                      <div className="day-month">{val.month}</div>  
                    </div>
                      <Link
                        to="#"
                        className="text-decoration-none"
                        onClick={() => handleLink(val.is_event_private,val.id)}
                      >
                        <h5>
                          {val.event_title}{" "}
                          {/*(Ages {val.age_start} - {val.age_end})*/}
                        </h5>
                      </Link>
                      <p>{val.event_address}</p>
                      {(() => {
                if (val.age_start==='' && val.age_end==='') {
                  } else if (val.age_start!=='' && val.age_end==='') {
                    return ( <h3>Age {val.age_start}</h3>)
                  }else if (val.age_start==='' && val.age_end!=='') {
                      return ( <h3>Age {val.age_end}</h3>)
                  }else if (val.age_start!=='' && val.age_end!=='') {
                    return ( <h3>Ages {val.age_start} - {val.age_end}</h3>)
                  }
                })()}
                      <Link
                        to="#"
                        className="text-decoration-none"
                        onClick={() => handleLink(val.is_event_private,val.id)}
                      >
                        <div className="get-ti">
                          <Link
                            to="#"
                            className="w-100 text-decoration-none"
                          >
                            GET TICKETS
                          </Link>
                        </div>
                      </Link>
                    </div>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          )}
        </div>

        <div className="text-center mt-4">
          <button className="btn" onClick={() => navigate("/upcoming-events")}>
            BROWSE ALL EVENTS
          </button>
        </div>
      </div>

      <div className="accors accordi good pt-0">
        <div className="row">
          <div className="col-md-6">
            <h2>FAQ</h2>
            <h3>Good to know</h3>
          </div>
          <div className="col-md-6">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  What is speed dating, and how does it work?
                </Accordion.Header>
                <Accordion.Body>
                  Speed dating is a fun and efficient way to meet multiple
                  singles in one night. At our events, you’ll go on 18 - 22
                  mini - dates, each lasting 5 minutes. After each date, you’ll mark on your match card whether you’d like to see the
                  person again. If it’s a mutual match, we’ll send you each
                  other’s contact details the next day!
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  How long does a speed dating event last?
                </Accordion.Header>
                <Accordion.Body>
                  Our speed dating events typically last 2 to 2.5 hours,
                  including a welcome introduction, the speed dating rounds, and
                  time for mingling before and after the event.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  How many people will I meet at a speed dating event?
                </Accordion.Header>
                <Accordion.Body>
                  You’ll typically meet 18 - 22 singles throughout the
                  evening, depending on the event. We ensure an even male - to
                  - female ratio to create the best experience possible.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  What should I wear to a speed dating event?
                </Accordion.Header>
                <Accordion.Body>
                  We recommend smart casual attire — dress in something you feel
                  confident and comfortable in. First impressions count, so it’s always good to put in a little effort!
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  What if I don’t find someone I’m interested in?
                </Accordion.Header>
                <Accordion.Body>
                  There’s no pressure to match with anyone! Speed dating is a
                  great way to meet new people, practice dating in real life,
                  and expand your social circle. Even if you don’t meet a
                  romantic match, many attendees leave with new friends or
                  connections.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  How do I receive my matches?
                </Accordion.Header>
                <Accordion.Body>
                  After the event, we’ll review all the match cards. If you
                  and someone else both select each other, we’ll email you
                  your mutual matches the next day with their contact details.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6">
                <Accordion.Header>
                  What happens if there are uneven numbers of men and women?
                </Accordion.Header>
                <Accordion.Body>
                  We do our best to maintain an equal number of men and women at
                  every event. If an uneven ratio occurs, we ensure fair
                  rotation so that everyone still gets plenty of dates
                  throughout the night.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>
                  Is speed dating better than dating apps?
                </Accordion.Header>
                <Accordion.Body>
                  Yes! Speed dating lets you meet real people, face - to - face, without the frustration of endless texting or ghosting. You’ll know instantly if there’s a connection — no catfishing,
                  no swiping, just real inte ractions.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="8">
                <Accordion.Header>
                  Can I come to a speed dating event alone?
                </Accordion.Header>
                <Accordion.Body>
                  Absolutely! Many people come solo, and it’s a welcoming and
                  friendly atmosphere. If you’re nervous, don’t worry — our
                  hosts will guide you through the event and make sure you feel
                  comfortable.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="9">
                <Accordion.Header>
                  What if I meet someone I already know?
                </Accordion.Header>
                <Accordion.Body>
                  It happens! If you spot a familiar face, take it as a sign
                  that you both have great taste in events. Most people take it
                  lightly and continue with the experience — you never know,
                  sparks might fly this time!
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="10">
                <Accordion.Header>
                  What age groups do you cater to?
                </Accordion.Header>
                <Accordion.Body>
                  We host speed dating events for different age ranges,
                  typically 20s – 50s. Check our upcoming events page to find
                  the best event for your age group.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="11">
                <Accordion.Header>
                  Where do YFMF speed dating events take place?
                </Accordion.Header>
                <Accordion.Body>
                  Our speed dating events take place at top venues in Dublin,
                  Galway, Cork, Limerick, and London! Locations are carefully
                  chosen to provide a relaxed and welcoming atmosphere.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="12">
                <Accordion.Header>
                  How do I sign up for a speed dating event?
                </Accordion.Header>
                <Accordion.Body>
                  It’s easy! Just visit our Upcoming Events page, select the
                  event you want to attend, and book your ticket online.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="13">
                <Accordion.Header>
                  What is the cancellation or refund policy?
                </Accordion.Header>
                <Accordion.Body>
                  Tickets are fully refundable up to 48 hours prior to the event. If you are looking to cancel within 48 hours of the event, please email hello@yourfriendmyfriend.ie and we will do our best to resell your ticket for you.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="14" className="lasty">
                <Accordion.Header>
                  Do I have to talk to everyone?
                </Accordion.Header>
                <Accordion.Body>
                  Yes, that’s part of the fun! Everyone will have 5 minutes
                  per date, but you’re under no pressure — if you don’t
                  feel a connection, simply mark it on your match card and move
                  on to the next conversation.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
      <Appqr />
      <Footer />
    </>
  );
};

export default SpeedDatingPage;
